import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { BaseComponent } from 'src/app/components/base/base.component';
import { UIState } from 'src/app/store/ui.states';
import { ScrollHelper } from 'src/app/services/helper/scroll-helper.services';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MFAService } from 'src/app/services/auth/mfa.service';
import { Title } from '@angular/platform-browser';
import { SessionStorageKey } from 'src/app/constants/constant';
import { DataLayerService } from 'src/app/shared/data-layer.service';
import { SessionService } from 'src/app/shared/session.service';

@Component({
    selector: 'mfa-reset-component',
    templateUrl: './mfa-reset-component.html',
    styleUrls: ['./mfa-reset-component.scss'],
    standalone: false
})
export class MFAResetComponent extends BaseComponent implements OnInit {
  resetSuccess: boolean = false;
  userName: string = '';
  resultVerified: boolean = false;
  titlePrefix: string = '';
  mfaReset:boolean = false;

  constructor(private router: Router, private route: ActivatedRoute, protected uiStore: Store<UIState>,
    private mfaService: MFAService, private authService: AuthService, private titleService: Title,private sessionService:SessionService,
    protected viewportScroller: ViewportScroller, protected scrollHelper: ScrollHelper, private dataLayerService: DataLayerService) {
    super(uiStore, viewportScroller, scrollHelper);
  }

  onNavigateLinkClick() {
    this.authService.logOutAndRedirect();
  }

  onResetMfaClick() {
    this.mfaService.sendResetMFANotification(this.userName).toPromise().then(() => {
      sessionStorage.setItem(SessionStorageKey.MFAResetUserName, this.userName);
      this.router.navigateByUrl('mfaresetnotification/success');
    });
  }

  ngOnInit() {
    this.dataLayerService.pushPageViewEvent();
    this.route.queryParams.subscribe(para => {
      this.mfaService.resetMFA(para.t).toPromise().then(() => {
        this.resetSuccess = true;
        this.resultVerified = true;
        this.titleService.setTitle(`Success - Additional security Reset - GCA`);
      }).catch((er: any) => {
        this.resetSuccess = false;
        this.resultVerified = true;
        this.titleService.setTitle(`Error - Additional security Reset - GCA`);
        if (er.error.error == 'INVALID_TICKET') {
          this.userName = er.error.error_description;
          this.mfaReset = er.error.mfa_reset_inprogress;
        }
      });
    });
  }
}
